<template>
  <div>
    <organization-table v-if="isSuperUser || isStaffUser || isPartner" />
    <div class="row">
      <div class="col-12">
        <loading-card v-if="isLoading" :title="pageType" />
        <card v-show="!isLoading" :title="pageType">
          <div class="row">
            <div class="col-md-4 offset-md-8">
              <fg-input type="text"
                placeholder="Search"
                v-model="searchTerm"
                addonRightIcon="search"
                :iconClasses="['clickable']">
              </fg-input>
            </div>
          </div>
          <div class="frame" v-if="(isStaffUser || isSuperUser || isPartner) && !selectedOrganization">
            <div class="table-active row recursive-row">
              <div class="col-12 text-center">
                <p>Please select an organization.</p>
              </div>
            </div>
          </div>
          <div class="frame" v-else-if="!groups || groups.length <= 0">
            <div class="table-active row recursive-row">
              <div class="col-12 text-center">
                <p>No groups were found.</p>
              </div>
            </div>
          </div>
          <div v-else>
            <recursive-row :group="groups" :pageType="pageType" :searchTerm="searchTerm" :level=0 />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationTable from '../components/Tables/OrganizationTable.vue';
import LoadingCard from '../components/Cards/LoadingCard.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    OrganizationTable,
    LoadingCard
  },
  props: {
    pageType: String
  },
  data() {
    return {
      isLoading: false,
      searchTerm: ""
    };
  },
  created() {
    if (this.topLevelGroup) {
      this.fetchGroups();
    }
  },
  methods: {
    async fetchGroups() {
      this.isLoading = true;
      this.searchTerm = "";
      await this.$store.dispatch('group/fetchGroups', this.topLevelGroup);
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters('group', ['groups', 'topLevelGroup']),
    ...mapGetters('user', ['isSuperUser', 'isStaffUser', 'isPartner']),
    ...mapGetters('organization', ['selectedOrganization'])
  },
  watch: {
    topLevelGroup() {
      this.fetchGroups();
    }
  }
};
</script>
